(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["black-friday-reviews"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  new Swiper('.black_friday_reviews .swiper-container', {
    breakpoints: {
      320: {
        slidesPerView: "auto",
        loop: false,
        spaceBetween: 21,
        freeMode: true,
      },
      1024: {
        slidesPerView: 2,
        loop: false,
      },
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["click-results-product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () =>  {
    const swiper = new Swiper('.BA-section-product .swiper-container', {
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: "auto",
          spaceBetween: 0,
        },
      },
      navigation: {
        nextEl: '.BA-section-product .navigation .swiper-button-next',
        prevEl: '.BA-section-product .navigation .swiper-button-prev'
      },
      on: {
        init: s => {
          document.querySelectorAll('.BA-section-product [data-swiper-slider]').forEach(el => {
            el.innerHTML = `${s.realIndex + 1} / ${s.slides.length}`;
          });
        },
        slideChange: s => {
          // Actualiza el contador al cambiar de slide
          document.querySelectorAll('.BA-section-product [data-swiper-slider]').forEach(el => {
            el.innerHTML = `${s.realIndex + 1} / ${s.slides.length}`;
          });
        }
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["click-results-video"]) return;
  try {
    
  const onMutedClickResults = (event) => {
    const figure = event.target.closest('.swiper-slide.video');
    if (!figure) return;
    const video = figure.querySelector('video');
    if (!video) return;
    video.hasAttribute('muted') ? video.removeAttribute('muted') : video.setAttribute('muted', '');
    video.muted = !video.muted;
    event.target.classList.toggle('is-muted', video.muted);
  }
  window.onMutedClickResults = onMutedClickResults;

  swiperResultsVideoThumbs = new Swiper('.BA_section_video .swiper-container.thumbs', {
    slidesPerView: 3,
    spaceBetween: 12,
    loop: false,
    breakpoints: {}
  });
  swiperResultsVideo = new Swiper('.BA_section_video .swiper-container.main', {
    slidesPerView: 1,
    spaceBetween: 70,
    loop: false,
    breakpoints: {},
    thumbs: {
      swiper: swiperResultsVideoThumbs,
    },
    on: {
      slideChange: s => {
        clickResultsVideo.forEach((customer, index) => {
          if (index === s.realIndex) {
            document.querySelectorAll('.BA_section_video [data-result-title]').forEach(el => {
              el.innerText = `${customer.title}`;
            });
            document.querySelectorAll('.BA_section_video [data-result-name]').forEach(el => {
              el.innerText = `${customer.name}`;
            });
            document.querySelectorAll('.BA_section_video [data-result-description]').forEach(el => {
              el.innerText = customer.description;
            });
          }
        });
      }
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["counterfits"]) return;
  try {
    
  new Swiper(".counterfits .swiper-container", {
      breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      1024: {
        slidesPerView: "auto",
        spaceBetween: 0,
      },
    },
    navigation: {
      nextEl: '.counterfits .navigation .swiper-button-next',
      prevEl: '.counterfits .navigation .swiper-button-prev'
    },
    on: {
      init: s => {
        document.querySelectorAll('.counterfits [data-swiper-slider]').forEach(el => {
            el.innerHTML = `${s.realIndex + 1} / ${s.slides.length}`;
        });
      },
      slideChange: s => {
        document.querySelectorAll('.counterfits [data-swiper-slider]').forEach(el => {
            el.innerHTML = `${s.realIndex + 1} / ${s.slides.length}`;
        });
      }
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-to-use"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () =>  {
    const swiper = new Swiper('.how_to_use .swiper-container', {
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 24,
        },
        1024: {
          slidesPerView: "auto",
          spaceBetween: 24,
        },
      },
      navigation: {
        nextEl: '.how_to_use .navigation .swiper-button-next',
        prevEl: '.how_to_use .navigation .swiper-button-prev'
      },
      on: {
        init: s => {
          document.querySelectorAll('.how_to_use [data-swiper-slider]').forEach(el => {
            el.innerHTML = `${s.realIndex + 1} / ${s.slides.length}`;
          });
        },
        slideChange: s => {
          // Actualiza el contador al cambiar de slide
          document.querySelectorAll('.how_to_use [data-swiper-slider]').forEach(el => {
            el.innerHTML = `${s.realIndex + 1} / ${s.slides.length}`;
          });
        }
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["info-banner-title"]) return;
  try {
    
    document.addEventListener('DOMContentLoaded', () =>  {

    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () =>  {
    const swiper = new Swiper('.ingredients .swiper-container', {
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 24,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
      },
      navigation: {
        nextEl: '.ingredients .navigation .swiper-button-next',
        prevEl: '.ingredients .navigation .swiper-button-prev'
      },
      on: {
        init: s => {
          document.querySelectorAll('.ingredients [data-swiper-slider]').forEach(el => {
            el.innerHTML = `${s.realIndex + 1} / ${s.slides.length}`;
          });
        },
        slideChange: s => {
          // Actualiza el contador al cambiar de slide
          document.querySelectorAll('.ingredients [data-swiper-slider]').forEach(el => {
            el.innerHTML = `${s.realIndex + 1} / ${s.slides.length}`;
          });
        }
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  window.location.href="/cart/checkout"

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-slider"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () =>  {
    const swiper = new Swiper('.products_slider .swiper-container', {
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 24,
        },
        1024: {
          slidesPerView: "auto",
          spaceBetween: 24,
        },
      },
      navigation: {
        nextEl: '.products_slider .navigation .swiper-button-next',
        prevEl: '.products_slider .navigation .swiper-button-prev'
      },
      on: {
        init: s => {
          document.querySelectorAll('.products_slider [data-swiper-slider]').forEach(el => {
            el.innerHTML = `${s.realIndex + 1} / ${s.slides.length}`;
          });
        },
        slideChange: s => {
          document.querySelectorAll('.products_slider [data-swiper-slider]').forEach(el => {
            el.innerHTML = `${s.realIndex + 1} / ${s.slides.length}`;
          });
        }
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["science-backed-funnels"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    if (typeof Swiper === 'undefined') return;

    document.querySelectorAll('.science_funnels .slider').forEach((slider) => {
      if (slider.classList.contains('swiper-initialized')) return;

      new Swiper(slider, {
        autoHeight: false,
        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 31,
            allowTouchMove: true,
            initialSlide: 1.5,
          },
          1024: {
            slidesPerView: 'auto',
            spaceBetween: 0,
            allowTouchMove: false,
          },
        },
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["science-backed"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const swiper = new Swiper('.science_backed .swiper-container', {
      autoHeight: false,
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        1024: {
          slidesPerView: 'auto',
          spaceBetween: 0,
        },
      },
      navigation: {
        nextEl: '.science_backed .navigation .swiper-button-next',
        prevEl: '.science_backed .navigation .swiper-button-prev',
      },
      on: {
        init: (s) => {
          document.querySelectorAll('.science_backed [data-swiper-slider]').forEach((el) => {
            el.innerHTML = `${s.realIndex + 1} / ${s.slides.length}`;
          });
        },
        slideChange: (s) => {
          // Actualiza el contador al cambiar de slide
          document.querySelectorAll('.science_backed [data-swiper-slider]').forEach((el) => {
            el.innerHTML = `${s.realIndex + 1} / ${s.slides.length}`;
          });
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();
})();
